/* eslint-disable sort-keys */
const graphCategories: { [key: string]: number } = {
  "High Level": 1,
  "Project Dashboard": 2,
  "View by All": 3,
  "Servicing Providers": 4,
  "NCP": 5
};

interface DatadogGraphs {
  [key: string]: DatadogGraphsApiResponse[],
}

interface DatadogGraphsApiResponse {
  embedUrl: string;
  graphQuery: string;
}

export { graphCategories, DatadogGraphs, DatadogGraphsApiResponse };